import { Box } from "@mui/material";

export function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{ height: "100%" }}
      {...other}
    >
      <Box sx={{ p: 2, height: "100%", boxSizing: "border-box", display: value !== index ? "none" : "flex", flexDirection: "column" }}>
        {children}
      </Box>
    </div>
  );
}